import { ICacheInfoAccessor } from '../contracts/i-cache-info.accessor';
import { ICacheService } from '../contracts/i-cache.service';
import { ICacheInfo, INgCacheOptions } from './cache.models';

export class NgCacheInfoAccessor<TEntity> implements ICacheInfoAccessor<TEntity> {
  public constructor(private readonly ngCacheService: ICacheService) {}

  public getCacheValueInfo(id: any, getKey: (id: any) => string, retrieve: (entity: TEntity) => TEntity): ICacheInfo<TEntity> {
    return this.ngCacheService.getCacheValueInfo(getKey(id), retrieve);
  }

  public set(id: any, getKey: (id: any) => string, value: TEntity, options: INgCacheOptions): void {
    this.ngCacheService.set(getKey(id), value, options);
  }

  public remove(id: any, getKey: (id: any) => string): void {
    this.ngCacheService.remove(getKey(id));
  }
}
